@if (isDegraded && !isDismissed) {
  <!-- Bandeau app-level -->
  <div class="alert alert-app-level alert-warning" role="alert">
    <div class="alert-items">
      <div class="alert-item static">
        <div class="alert-icon-wrapper">
          <cds-icon class="alert-icon" shape="warning-standard"></cds-icon>
        </div>
        <div class="alert-text">
          La plateforme est en état dégradé. Certaines fonctionnalités peuvent ne pas être
          disponibles.
        </div>
        <div class="alert-actions">
          <button class="btn alert-action" type="button" (click)="toggleDetails()">
            {{ showDetails ? 'Masquer les détails' : 'Voir les détails' }}
          </button>
        </div>
      </div>
    </div>
    <button class="close" type="button" aria-label="Fermer" (click)="dismiss()">
      <cds-icon aria-hidden="true" shape="close"></cds-icon>
    </button>
  </div>
  <!-- Panneau de détails -->
  @if (showDetails) {
    <div class="pdb-details">
      <div class="pdb-details__header">
        <cds-icon shape="shield" size="sm"></cds-icon>
        <span>Diagnostic de la plateforme</span>
      </div>
      <!-- Diagnostic indisponible -->
      @if (!checks) {
        <p class="pdb-details__unavailable">
          <cds-icon shape="error-standard" class="pdb-check-icon pdb-check-icon--fail"></cds-icon>
          Diagnostic indisponible — le backend Keycloak n'a pas pu être joint.
        </p>
      } @else {
        <ul class="pdb-checklist">
          <!-- Realm accessible -->
          @if (checks?.realm_accessible; as check) {
            <li class="pdb-check-item">
              <cds-icon
                [attr.shape]="check.ok ? 'success-standard' : 'error-standard'"
                [class]="'pdb-check-icon ' + (check.ok ? 'pdb-check-icon--ok' : 'pdb-check-icon--fail')"
              ></cds-icon>
              <span>
                Realm Keycloak {{ check.ok ? 'accessible' : 'inaccessible' }}
                @if (!check.ok && check.detail) {
                  <span class="pdb-check-detail"
                    >— {{ check.detail }}</span
                    >
                  }
                </span>
              </li>
            }
            <!-- Rôles realm -->
            @if (checks?.realm_roles; as check) {
              <li class="pdb-check-item">
                <cds-icon
                  [attr.shape]="check.ok ? 'success-standard' : 'error-standard'"
                  [class]="'pdb-check-icon ' + (check.ok ? 'pdb-check-icon--ok' : 'pdb-check-icon--fail')"
                ></cds-icon>
                <span>
                  Rôles realm {{ check.ok ? 'corrects' : 'manquants' }}
                  @if (!check.ok && check.missing?.length) {
                    : <code>{{ check.missing.join(', ') }}</code>
                  }
                </span>
              </li>
            }
            <!-- Rôles client GUI (affiché seulement si non null) -->
            @if (checks?.gui_client_roles; as check) {
              <li class="pdb-check-item">
                <cds-icon
                  [attr.shape]="check.ok ? 'success-standard' : 'error-standard'"
                  [class]="'pdb-check-icon ' + (check.ok ? 'pdb-check-icon--ok' : 'pdb-check-icon--fail')"
                ></cds-icon>
                <span>
                  Client GUI (<code>{{ check.client_id }}</code
                  >) : rôles {{ check.ok ? 'corrects' : 'manquants' }}
                  @if (!check.ok && check.missing?.length) {
                    : <code>{{ check.missing.join(', ') }}</code>
                  }
                </span>
              </li>
            }
            <!-- Admin assigné -->
            @if (checks?.admin_user_assigned; as check) {
              <li class="pdb-check-item">
                <cds-icon
                  [attr.shape]="check.ok ? 'success-standard' : 'error-standard'"
                  [class]="'pdb-check-icon ' + (check.ok ? 'pdb-check-icon--ok' : 'pdb-check-icon--fail')"
                ></cds-icon>
                <span>
                  Administrateur {{ check.ok ? 'assigné' : 'non assigné au rôle admin_sbvp' }}
                  @if (!check.ok && check.detail) {
                    <span class="pdb-check-detail"
                      >— {{ check.detail }}</span
                      >
                    }
                  </span>
                </li>
              }
            <!-- Mapping client de management -->
            @if (checks?.management_client_mapping; as check) {
              <li class="pdb-check-item">
                <cds-icon
                  [attr.shape]="check.ok ? 'success-standard' : 'error-standard'"
                  [class]="'pdb-check-icon ' + (check.ok ? 'pdb-check-icon--ok' : 'pdb-check-icon--fail')"
                ></cds-icon>
                <span>
                  Mapping client de management {{ check.ok ? 'configuré' : 'absent ou en erreur' }}
                  @if (check.detail) {
                    <span class="pdb-check-detail">— {{ check.detail }}</span>
                  }
                </span>
              </li>
            }
            </ul>
            <!-- Erreur interne backend -->
            @if (checks?.error) {
              <p class="pdb-details__error">Erreur interne : {{ checks!.error }}</p>
            }
          }
          <!-- Action admin -->
          @if (sbvpAuth.isAdminSbvp$ | async) {
            <div class="pdb-details__actions">
              <button
                class="btn btn-warning btn-sm"
                type="button"
                [disabled]="isRepairLoading"
                (click)="repair()"
              >
                @if (isRepairLoading) {
                  <span class="spinner spinner-sm spinner-inline"></span>
                }
                @if (!isRepairLoading) {
                  <cds-icon shape="tools"></cds-icon>
                }
                {{ isRepairLoading ? 'Réparation en cours…' : 'Réparer la plateforme' }}
              </button>
              <button class="btn btn-warning-outline btn-sm" type="button" (click)="openRelanceModal()">
                <cds-icon shape="refresh"></cds-icon>
                Relancer l'initialisation
              </button>
              @if (repairError) {
                <clr-alert clrAlertType="danger" [clrAlertClosable]="true" (clrAlertClosedChange)="repairError = null">
                  <clr-alert-item>
                    <span class="alert-text">{{ repairError }}</span>
                  </clr-alert-item>
                </clr-alert>
              }
            </div>
          }
        </div>
      }
    }

    <!-- Modal relancement (admin uniquement) -->
    <clr-modal [(clrModalOpen)]="showRelanceModal" [clrModalClosable]="!isLoading">
      <h3 class="modal-title">Relancer l'initialisation</h3>
      <div class="modal-body">
        @if (errorMessage) {
          <clr-alert clrAlertType="danger" [clrAlertClosable]="false">
            <clr-alert-item>
              <span class="alert-text">{{ errorMessage }}</span>
            </clr-alert-item>
          </clr-alert>
        }

        <form [formGroup]="relanceForm" novalidate>
          <h6 class="pdb-modal__section-title">Service Account Keycloak</h6>

          <clr-input-container>
            <label>Client ID</label>
            <input
              clrInput
              type="text"
              formControlName="sa_client_id"
              placeholder="bootstrap-sa"
              autocomplete="username"
              />
            <clr-control-error>Champ requis</clr-control-error>
          </clr-input-container>

          <clr-password-container>
            <label>Client Secret</label>
            <input
              clrPassword
              formControlName="sa_client_secret"
              placeholder="••••••••••••"
              autocomplete="current-password"
              />
            <clr-control-error>Champ requis</clr-control-error>
          </clr-password-container>

          <h6 class="pdb-modal__section-title">Administrateur SBVP</h6>

          <clr-input-container>
            <label>Email</label>
            <input
              clrInput
              type="email"
              formControlName="admin_email"
              placeholder="admin@example.com"
              />
            <clr-control-error>Email invalide ou requis</clr-control-error>
          </clr-input-container>

          <div class="clr-row">
            <div class="clr-col-6">
              <clr-input-container>
                <label>Prénom</label>
                <input clrInput type="text" formControlName="admin_first_name" placeholder="Prénom" />
                <clr-control-error>Champ requis</clr-control-error>
              </clr-input-container>
            </div>
            <div class="clr-col-6">
              <clr-input-container>
                <label>Nom</label>
                <input clrInput type="text" formControlName="admin_last_name" placeholder="Nom" />
                <clr-control-error>Champ requis</clr-control-error>
              </clr-input-container>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline"
          [disabled]="isLoading"
          (click)="showRelanceModal = false"
          >
          Annuler
        </button>
        <button
          type="button"
          class="btn btn-warning"
          [disabled]="relanceForm.invalid || isLoading"
          (click)="submitRelance()"
          >
          @if (isLoading) {
            <span class="spinner spinner-sm spinner-inline"></span>
          }
          {{ isLoading ? 'Relancement en cours…' : 'Relancer' }}
        </button>
      </div>
    </clr-modal>
